import { defineMessages } from 'react-intl';

export const notificationMessages = defineMessages({
  menuItemLabel: {
    defaultMessage: 'Configure notifications',
    id: 'rilMmuTx1q34cH6K',
    description: 'Label for the Configure notifications menu item',
  },
  notificationSettingsModalTitle: {
    defaultMessage: 'Configure notifications',
    id: 'Vp5mQzQ25g1cKY0D',
    description: 'Title for the Configure notifications menu item',
  },
  notificationsToggle: {
    defaultMessage:
      'Turn {notificationEnabled, select, true {off} other {on}} notifications',
    id: 'YINK0Te9FAqCqP/C',
    description:
      'Label used to describe the button that toggles notify button notifications on or off',
  },
  notificationsOverlayHeading: {
    defaultMessage:
      'Notifications are turned {notificationEnabled, select, true {on} other {off}}',
    id: 'ylJmm6+j/5dJx8/1',
    description: 'Text used for the notify button overlay heading',
  },
  notificationsEnabled: {
    defaultMessage: "You'll be notified about updates via email.",
    id: '6ZC5vGSgjnplvo7x',
    description:
      'Additional information text used for the notify button overlay when notifications are enabled',
  },
  notificationsDisabled: {
    defaultMessage: "You won't be notified about updates via email.",
    id: 'mSrICwXdDHSlEwIq',
    description:
      'Additional information text used for the notify button overlay when notifications are disabled',
  },
  copyPermissions: {
    defaultMessage: 'Copy and share missing permissions with your admin',
    id: 'x3FIfL6niq1MnAvw',
    description: 'Text used for the notify button overlay/tost content text',
  },
  copyMissingPermissions: {
    defaultMessage: 'Copy missing permissions',
    id: 'qEw4R8BQ3vYI7C8R',
    description: 'Text used for the notify button toast button text',
  },
  noPermissionsHeading: {
    defaultMessage:
      'No permission to turn {notificationEnabled, select, true {off} other {on}} notifications',
    id: 'tjTPi9AKvehOhky2',
    description: 'Text used for the notify button toast content text',
  },
  limitReachedToastHeading: {
    defaultMessage: "Notification couldn't be created",
    id: 'g1uJ6PuX78GYkCnv',
    description:
      'Text used for the notify button toast heading when the limit is reached.',
  },
  limitReached: {
    defaultMessage:
      'No notification could be created, the limit for notification type {notificationType} is reached.',
    id: 'ibW/chmVU64qftcF',
    description:
      'Text used for the notify button toast content when the limit is reached.',
  },
  genericError: {
    defaultMessage: 'Error',
    id: 'yPyYlsR+hsqOmSHt',
    description: 'Title for generic error toast',
  },
  genericErrorMessage: {
    defaultMessage: 'Something went wrong. Please try again later.',
    id: '7cB3GSVBVIfSrN8y',
    description: 'Message for the generic error toast',
  },
});
